import { browserService } from "widgets-module/services/browser.service";
import { deviceService } from "widgets-module/services/device.service";

import { AccessibilityComponent } from "./components/accessibility/accessibility.component";
import { GoTopButtonComponent } from "./components/go-top-button/go-top-button.component";
import { HomeSlickComponent } from "./components/homeslick.component";
import { NotificationService } from "./components/notification/notification.service";
import { PageExportService } from "./components/page-export/page.export.service";
import { PageRatingComponent } from "./components/page-rating/page-rating.component";
import { RollingNumbersService } from "./components/rolling-numbers/rolling-numbers.service";
import { SearchPageComponent } from "./components/search-page/search-page.component";

class WidgetsModule {
    public init(): void {
        browserService.init();
        deviceService.init();

        $.extend($, {
            pcg: {
                frontend: {
                    goTopButton: new GoTopButtonComponent()
                },
                widgets: {
                    accessibilityComponent: new AccessibilityComponent(),
                    homeSlickComponent: HomeSlickComponent,
                    notificationService: new NotificationService(),
                    pageRatingComponent: new PageRatingComponent(),
                    pageExportService: new PageExportService(),
                    searchPageComponent: new SearchPageComponent(),
                    rollingNumbersService: new RollingNumbersService()
                }
            }
        });
    }
}

const widgets = new WidgetsModule();

$(() => widgets.init());
